import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {getAllocationTotal} from '../../scheduling/project_allocation_logic';
import Util from '../../../forecast-app/shared/util/util';

class AllocationDetailBox extends Component {
	getParentTextFromAllocation(allocation) {
		if (allocation.projectGroupId) {
			const projectGroup = this.props.globalData.projectGroups.find(projectGroup => projectGroup.id === allocation.projectGroupId);
			return `X${projectGroup.companyProjectGroupId} ${projectGroup.name}`;
		} else if (allocation.projectId) {
			const project = this.props.globalData.projects.find(project => project.id === allocation.projectId);
			return `P${project.companyProjectId} ${project.name}`;
		} else {
			const idleTime = this.props.globalData.idleTimes.find(idleTime => idleTime.id === allocation.idleTimeId);
			if (idleTime) {
				return idleTime.name;
			} else {
				// Prevents crash on some strange idle times with no name that should not be possible to create anymore but could potentially still exist somewhere
				return '';
			}
		}
	}

	getAllocationType(allocation) {
		const {formatMessage} = this.props.intl;

		if (allocation.holidayCalendarId) {
			return formatMessage({id: 'common.holiday'});
		}

		if (allocation.idleTimeId) {
			return formatMessage({id: allocation.isIdleTimeInternal ? 'common.internal_time' : 'common.time_off'});
		}

		if (allocation.projectId || allocation.projectGroupId) {
			const project = this.props.globalData.projects.find(project => (allocation.projectGroupId ? project.projectGroupId === allocation.projectGroupId : project.id === allocation.projectId));
			if (project && !project.useManualAllocations) {
				return formatMessage({id: 'scheduling.task_allocation'});
			}

			return formatMessage({id: 'scheduling.project_allocation'});
		}
		if (allocation.parent) {
			return formatMessage({id: 'scheduling.task_allocation'});
		}
		return '';
	}

	render() {
		const {allocation, globalData, positionX, positionY} = this.props;
		const {formatMessage} = this.props.intl;
		let totalEstimate = this.props.taskAllocationTotalEstimate;
		const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
		const showRight = positionX + 200 < window.innerWidth;
		const showTop = positionY + 350 < window.innerHeight;
		const project = allocation.projectId && globalData.projects.find(project => project.id === allocation.projectId);
		const clientName = project ? (project.clientId ? globalData.clients.find(client => client.id === project.clientId).name : null) : null;

		if (totalEstimate === null && allocation.wednesday !== null && allocation.wednesday !== undefined) {
			const total = getAllocationTotal(allocation);

			totalEstimate = Util.convertMinutesToFullHour(total, this.props.intl, true);
		}

		return (
			<>
				<div className={'white-triangle ' + (showRight ? 'right ' : 'left ') + (showTop ? 'top' : 'bottom')} />
				<div className="detail-box-inner-container detail-box-allocation-container">
					<div className="detail-box-allocation-item detail-box-inner-headline">{formatMessage({id: 'common.allocation'})}</div>
					<div className="detail-box-allocation-item detail-box-allocation-name">
						<div className="label">{formatMessage({id: 'common.project-name'})}</div>
						<div className="content">
							{allocation.holidayCalendarId
								? allocation.name
								: allocation.parent
								? `${allocation.parent.companyProjectGroupId ? 'X' + allocation.parent.companyProjectGroupId : 'P' + allocation.parent.companyProjectId} ${allocation.parent.name}`
								: this.getParentTextFromAllocation(allocation)}
						</div>
					</div>
					{clientName ? (
						<div className="detail-box-allocation-item">
							<div className="label">{formatMessage({id: 'common.client'})}</div>
							<div className="content">{clientName}</div>
						</div>
					) : null}
					<div className="detail-box-allocation-item detail-box-allocation-dates">
						<div className="label">{formatMessage({id: 'common.date'})}</div>
						<div className={'content'}>{`${allocation.startDay} ${formatMessage({id: 'insights.component.list.column.' + months[allocation.startMonth - 1]})} ${allocation.startYear} - ${allocation.endDay} ${formatMessage({
							id: 'insights.component.list.column.' + months[allocation.endMonth - 1],
						})} ${allocation.endYear}`}</div>
					</div>
					<div className="detail-box-allocation-item detail-box-allocation-type">
						<div className="label">{formatMessage({id: 'common.type'})}</div>
						<div className="content">{this.getAllocationType(allocation)}</div>
					</div>
					{totalEstimate !== null && totalEstimate !== undefined ? (
						<div className="detail-box-allocation-item detail-box-allocation-total">
							<div className="label">{formatMessage({id: 'common.total'})}</div>
							<div className="content">{totalEstimate}</div>
						</div>
					) : null}
				</div>
			</>
		);
	}
}

AllocationDetailBox.propTypes = {
	allocation: PropTypes.object.isRequired,
	globalData: PropTypes.object.isRequired,
};

export default injectIntl(AllocationDetailBox);
